import { FC } from 'react';
import { BigFeedback, BigHeader, BlockContent } from '../../components';
import { META_URLS, SITE_CONTENT } from '../../appConstants';
import { HelmetSeo } from '../../components/HelmetSeo/HelmetSeo';
import styles from './styles.module.scss';
import { phoneRefactor } from '../../utils';

const MailLink = () => (
    <a href={`mailto:${SITE_CONTENT.MailInbox}`}>{SITE_CONTENT.MailInbox}</a>
);

export const InfoPage: FC = () => {
    window.scrollTo(0, 0);
    const { Phone, Page } = SITE_CONTENT;
    const { InfoPage } = META_URLS;

    return (
        <>
            <HelmetSeo
                title={Page[InfoPage].title}
                description={Page[InfoPage].description}
            />
            <BlockContent contentClass={styles.infoPage}>
                <BigHeader className={styles.title} title="Информация о компании" />

                <p>
                    <b>Полное наименование:</b>
                    Общество с ограниченной ответственностью &laquo;Кибер Форм
                    Системс&raquo;
                </p>

                <p>
                    <b>Адрес: юр/факт:</b>
                    108813, г. Москва, вн.тер.г. муниципальный округ Филимонковский, г.
                    Московский, ул Солнечная, д. 2А, стр. 2, этаж 2, ком. 210
                </p>

                <p>
                    <b>ИНН:</b>
                    7751076359
                </p>

                <p>
                    <b>ОГРН:</b>
                    1177746982819
                </p>

                <p>
                    <b>Адрес: юр/факт: </b>
                    108813, г. Москва, вн.тер.г. муниципальный округ Филимонковский, г.
                    Московский, ул Солнечная, д. 2А, стр. 2, этаж 2, ком. 210
                </p>
                <p>
                    <b>Основной ОКВЭД:</b>
                    62.01 Разработка компьютерного программного обеспечения
                </p>
                <p>
                    <b>Доп. ОКВЭД:</b>
                    62.02 Деятельность консультативная и работы в области компьютерных
                    технологий
                </p>
                <p>
                    <b>Тел.:</b>
                    <a href={`tel:${Phone}`}>{phoneRefactor(Phone)}</a>
                </p>
                <p>
                    <b>Адрес эл. почты:</b>
                    <MailLink />
                </p>
                <p>
                    <b>Услуги и цены:</b>
                    Аутсорс разработки ПО – от 2700 руб./час
                </p>
                <p>
                    <b>
                        Применяемые языки, фреймворки, ML-библиотеки, DevOps-инструменты и
                        СУБД:
                    </b>
                    <div>
                        Языки: python, javascript, typescript, go, rust, sql, yaml, html,
                        css
                    </div>
                    <div>
                        Фреймворки: django, flask, fastapi, react/next, vue/nuxt,
                        express,nest, react native ML-библиотеки: pytorch, sklearn,
                        tensorflow, pandas, numpy DevOps-инструменты: docker, k8s, docker
                        swarm, gitlab CI, grafana, prometheus, zabbix, sentry, glitchtip
                        СУБД: postgresql, clickhouse, redis
                    </div>
                </p>
                <p>
                    <b>Наличие исключительных прав на программы:</b>
                    ООО &quot;Кибер Форм Системс&quot; является правообладателем программы
                    &quot;OrthoDo&quot;. Свидетельство о государственной регистрации
                    программы для ЭВМ №2025618978. Дата государственной регистрации в
                    Реестре программ для ЭВМ: 11.04.2025 г.
                </p>
            </BlockContent>
            <BigFeedback />
        </>
    );
};
